// ##### 25-02-05 Komarov
// ##### 23-10-10 Komarov: TODO: параметры функции не передаются сюда, так есть ли в них смысл?..
// ##### 24-05-21 Komarov
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { selectDeviceType } from '../../../../Redux/selectors';
// ##### 25-05-21 Komarov
import Hotels from '../../../Library/Icons/hotels';
import { LargeScreenSearchContext } from './LargeScreenSearch';
import Switcher from './Switcher';
import SwitcherItem from './SwitcherItem';

// ##### Komarov 2025-07-14
const SwitcherTag = () => {
  const {
    toggler,
    align,
    hotels,
    // ##### 24-03-21 Komarov
    // tours
  } = useContext(LargeScreenSearchContext);
  // ##### 24-05-10 Komarov
  const deviceType = useSelector(selectDeviceType);

  // ##### 24-05-21 Komarov
  return (
    <Switcher name={'align'} changeHandler={toggler} active={align}>
      {/* ##### 23-04-01 Komarov */}
      <SwitcherItem value="HOTELS">
        {/* {Hotels(deviceType)} */}
        <Hotels deviceType={deviceType} />
        <h4>
          {
            // ##### 23-10-04 Komarov
            hotels
          }
        </h4>
      </SwitcherItem>
      {/* ##### 24-01-12 Komarov */}
      {/* <SwitcherItem value='TOURS'><SwitcherItem deviceType={deviceType} /><h4>
      {
        // ##### 23-10-04 Komarov
        tours
      }
    </h4>
    </SwitcherItem> */}
    </Switcher>
  );
};

export default SwitcherTag;
